import cleanUpResponse from '@/util/cleanUpResponse';

export default async function UpdateOrderLineItems(formData) {
  const response = await $.soap({
    body: {
        UpdateOrderLineItems: {
        $xmlns: 'http://dla.mil/ems/bpm/order/order_line_item',
        OrderFormTypeID: formData.orderFormTypeID,
        ChangedItems: {
            Item: formData.changedItems
        }
      }
    }
  });

  cleanUpResponse(response);
  return response;
}
